/**
 * É necessário que exista o objeto "laoder" em data.
 */
export default {
	methods: {
		$mx_setLoader(loader, bool) {
			this.loader[loader] = bool
		},

		$mx_setLoaderList(list, bool) {
			list.forEach((loader) => {
				this.$mx_setLoader(loader, bool)
			})
		},
	},
}
